import { render, staticRenderFns } from "./FilesTab.vue?vue&type=template&id=d7f2c3cc&scoped=true"
import script from "./FilesTab.vue?vue&type=script&lang=js"
export * from "./FilesTab.vue?vue&type=script&lang=js"
import style0 from "./FilesTab.vue?vue&type=style&index=0&id=d7f2c3cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f2c3cc",
  null
  
)

export default component.exports